export default "__VITE_ASSET__e0e5dddc__"